import { render, staticRenderFns } from "./NativeTrackingWarning.vue?vue&type=template&id=539e5312&lang=pug&"
import script from "./NativeTrackingWarning.vue?vue&type=script&lang=js&"
export * from "./NativeTrackingWarning.vue?vue&type=script&lang=js&"
import style0 from "./NativeTrackingWarning.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports